/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cta_Metric_ProductsInputs */

const en_cta_metric_products = /** @type {(inputs: Cta_Metric_ProductsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Products launched`)
};

const ar_cta_metric_products = /** @type {(inputs: Cta_Metric_ProductsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`منتج تم إطلاقه`)
};

const bn_cta_metric_products = /** @type {(inputs: Cta_Metric_ProductsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`লঞ্চ করা প্রোডাক্ট`)
};

const de_cta_metric_products = /** @type {(inputs: Cta_Metric_ProductsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produkte eingeführt`)
};

const es_cta_metric_products = /** @type {(inputs: Cta_Metric_ProductsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Productos lanzados`)
};

const fr_cta_metric_products = /** @type {(inputs: Cta_Metric_ProductsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produits lancés`)
};

const pt_cta_metric_products = /** @type {(inputs: Cta_Metric_ProductsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produtos lançados`)
};

const zh_cta_metric_products = /** @type {(inputs: Cta_Metric_ProductsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`产品推出`)
};

const tr_cta_metric_products = /** @type {(inputs: Cta_Metric_ProductsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piyasaya sürülen ürünler`)
};

const ru_cta_metric_products = /** @type {(inputs: Cta_Metric_ProductsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выпущены продукты`)
};

const pl_cta_metric_products = /** @type {(inputs: Cta_Metric_ProductsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produkty wprowadzone na rynek`)
};

/**
* | output |
* | --- |
* | "Products launched" |
*
* @param {Cta_Metric_ProductsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const cta_metric_products = /** @type {((inputs?: Cta_Metric_ProductsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cta_Metric_ProductsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_cta_metric_products(inputs)
	if (locale === "bn") return bn_cta_metric_products(inputs)
	if (locale === "de") return de_cta_metric_products(inputs)
	if (locale === "es") return es_cta_metric_products(inputs)
	if (locale === "fr") return fr_cta_metric_products(inputs)
	if (locale === "pt") return pt_cta_metric_products(inputs)
	if (locale === "zh") return zh_cta_metric_products(inputs)
	if (locale === "tr") return tr_cta_metric_products(inputs)
	if (locale === "ru") return ru_cta_metric_products(inputs)
	if (locale === "pl") return pl_cta_metric_products(inputs)
	return en_cta_metric_products(inputs)
});